import {
  isAllShows,
  isVodEpisodes,
  isVodGenresBlock,
  isVodMain,
  isVodPrograms,
  IVodItem,
} from '../../types'
import {
  Hero,
  VodEpisodes,
  VodGenresCarousel,
  VodPrograms,
} from '../../components/DynamicComponents'
import AllShows from '../../components/AllShows/AllShows'

export const vodItemToComponent = ({
  item,
  i,
}: {
  item: IVodItem
  i: number
}) => {
  const { grid_id } = item

  if (isVodMain(item)) {
    return <Hero item={item} key={`${i} ${grid_id}`} />
  }
  if (isVodEpisodes(item)) {
    return <VodEpisodes item={item} key={`${i} ${grid_id}`} />
  }
  if (isVodPrograms(item)) {
    return <VodPrograms item={item} key={`${i} ${grid_id}`} />
  }
  if (isVodGenresBlock(item)) {
    return <VodGenresCarousel item={item} key={`${i} ${grid_id}`} />
  }
  if (isAllShows(item)) {
    return <AllShows item={item} key={`${i} ${grid_id}`} />
  }

  return null
}
